import { DefaultAction } from './default-action.enum';

export enum UniqueDeviceActions {
  installSim = 'installSim',
  updateSim = 'updateSim',
  getLastPacket = 'getLastPacket',
  getCommandLog = 'getCommandLog',
  getDeviceLog = 'getDeviceLog',
  getDeviceLogHistory = 'getDeviceLogHistory',
  getDeviceJournal = 'getDeviceJournal',
  getStatistics = 'getStatistics',
  getTrips = 'getTrips',
  getTripsDaily = 'getTripsDaily',
  sendCommand = 'sendCommand',
  activate = 'activate',
  deactivate = 'deactivate',
  upload = 'upload',
  start = 'start',
}

export const DeviceAction = {
  ...DefaultAction,
  ...UniqueDeviceActions,
};
